import React from "react";
import { injectIntl } from "react-intl";

function FormattedMessageHtml({ intl, id, element = "span", ...props }) {
  const html = intl.formatMessage({ id });

  return React.createElement(element, {
    ...props,
    dangerouslySetInnerHTML: { __html: html }
  });
}
export default injectIntl(FormattedMessageHtml);



// WEBPACK FOOTER //
// ./src/modules/i18n/formatted-message-html.js